<template>
<div class="column" :class="size">
  <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/column.vue